// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2okbQ","question":"styles_question__v3bcr","description":"styles_description__3lp42"};